import Box from "@mui/material/Box";

export function MyAccountTabs({ children, className }) {
	return (
		<Box className={className} sx={{ paddingTop: 4 }}>
			{children}
		</Box>
	);
}
